package com.tregz.design.motion

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.w3c.dom.events.Event

private const val REDUCED_QUERY = "(prefers-reduced-motion: reduce)"

@Composable
actual fun isReducedMotion(): Boolean {
    // matchMedia can be missing (Node, old or embedded browsers) or throw; assume motion is allowed.
    val query = remember {
        try {
            window.matchMedia(REDUCED_QUERY)
        } catch (_: Throwable) {
            null
        }
    }
    var reduced by remember { mutableStateOf(query?.matches ?: false) }
    DisposableEffect(query) {
        if (query == null) return@DisposableEffect onDispose { }
        val listener: (Event) -> Unit = { reduced = query.matches }
        val modern = try {
            query.addEventListener("change", listener)
            true
        } catch (_: Throwable) {
            false
        }
        if (!modern) {
            // Safari < 14 only knows the deprecated addListener.
            try {
                query.asDynamic().addListener(listener)
            } catch (_: Throwable) {
            }
        }
        onDispose {
            try {
                if (modern) query.removeEventListener("change", listener)
                else query.asDynamic().removeListener(listener)
            } catch (_: Throwable) {
            }
        }
    }
    return reduced
}
